import { widgetTelemetry } from '../widgetTelemetry';
export class GasResolver {
    constructor(providers) {
        this.providers = providers || [];
    }
    getGas(args) {
        const { network, token } = args;
        const provider = this.providers.find(p => p.supportsNetwork(network));
        if (!provider)
            return;
        const finishTelemetry = widgetTelemetry.beginOperation('gas_estimation', { network: network.name, token: token?.symbol });
        try {
            return provider.getGas(args).then(result => {
                finishTelemetry(result ? 'succeeded' : 'unavailable');
                return result;
            }, error => {
                finishTelemetry('failed');
                throw error;
            });
        }
        catch (error) {
            finishTelemetry('failed');
            throw error;
        }
    }
}
